export default __webpack_public_path__ + "navigation-camera-geometry-framing-after-maneuver-enabled-1200-a61a1334a47cfeacbfd007d2ff4766de.png";